export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/052110ed88af1e512d5eeb805cb80c0c.jpg"
          alt="Professional Roofing Services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full">
        <div className="max-w-4xl">
          {/* Badges */}
          <div className="flex flex-wrap gap-3 mb-8">
            <span className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 backdrop-blur-md text-white text-sm font-medium border border-white/30">
              <i className="ri-shield-check-line mr-2"></i>
              Licensed &amp; Insured
            </span>
            <span className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 backdrop-blur-md text-white text-sm font-medium border border-white/30">
              <i className="ri-time-line mr-2"></i>
              24/7 Emergency Service
            </span>
            <span className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 backdrop-blur-md text-white text-sm font-medium border border-white/30">
              <i className="ri-star-fill mr-2 text-yellow-400"></i>
              A+ Rated
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 leading-tight">
            CABADAS ROOFING LLC
          </h1>

          {/* Subheading */}
          <p className="text-2xl md:text-3xl text-white/95 font-medium mb-8">
            Residential &amp; Commercial Roof Repairs in Florida
          </p>

          {/* Service Tags */}
          <div className="flex flex-wrap gap-3 mb-10">
            <span className="px-5 py-2 rounded-full border-2 border-white/80 text-white text-sm font-medium backdrop-blur-sm whitespace-nowrap">
              Leak Detection
            </span>
            <span className="px-5 py-2 rounded-full bg-orange-600 text-white text-sm font-semibold whitespace-nowrap">
              Storm Damage
            </span>
            <span className="px-5 py-2 rounded-full border-2 border-white/80 text-white text-sm font-medium backdrop-blur-sm whitespace-nowrap">
              Free Inspections
            </span>
            <span className="px-5 py-2 rounded-full border-2 border-white/80 text-white text-sm font-medium backdrop-blur-sm whitespace-nowrap">
              Fast Response
            </span>
          </div>

          {/* CTA Button */}
          <button
            onClick={scrollToContact}
            className="group inline-flex items-center px-8 py-4 bg-orange-600 text-white text-lg font-semibold rounded-full hover:bg-orange-700 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            SCHEDULE INSPECTION
            <i className="ri-arrow-right-up-line ml-3 text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center animate-bounce">
          <span className="text-white text-sm mb-2 font-medium">Scroll Down</span>
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
}